import { element } from 'angular';
var PromptMessageService = (function () {
    function PromptMessageService($rootScope, $q, $compile) {
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$compile = $compile;
        this.html = "\n    <div class=\"lightbox__container\">\n      <div class=\"lightbox__overlay\" ng-click=\"close()\"></div>\n      <div class=\"lightbox\">\n          <div class=\"prompt-message-header\">\n            <div class=\"prompt-message-header__icon\">\n                <cg-icon cg-icon-rounded-size-40\n                         cg-icon-size-28>\n                         error_outline\n                </cg-icon>\n            </div>\n            <div class=\"prompt-message-header__title\" content-dictionary=\"Warning\"></div>\n            <cg-icon class=\"prompt-message-header__close\" \n                     cg-icon-interactive \n                     cg-icon-size-30\n                     ng-click=\"close()\">\n                     close\n            </cg-icon>\n          </div>\n          <div class=\"prompt-message-content custom-rich-text\" content-dictionary=\"{{question}}\"></div>\n          <div class=\"prompt-message-buttons\">\n            <button type=\"button\" \n                    ng-click=\"onYes()\" \n                    content-dictionary=\"Yes\"\n                    class=\"prompt-message-button prompt-message-button--yes jbr-btn jbr-btn-square jbr-btn--white\">\n            </button>\n            <button type=\"button\"\n                    ng-click=\"onNo()\"\n                    content-dictionary=\"No\"\n                    class=\"prompt-message-button prompt-message-button--no jbr-btn jbr-btn-square jbr-btn--yellow\">\n            </button>\n          </div>\n      </div>\n    </div>\n  ";
    }
    PromptMessageService.prototype.create = function (question) {
        var deferred = this.$q.defer();
        var scope = this.$rootScope.$new();
        var content;
        scope.question = question;
        scope.close = function () {
            deferred.reject();
            content.remove();
        };
        scope.onNo = function () {
            deferred.reject();
            content.remove();
        };
        scope.onYes = function () {
            deferred.resolve();
            content.remove();
        };
        content = this.$compile(this.html)(scope);
        element('.master__container').append(content);
        return deferred.promise;
    };
    PromptMessageService.$inject = ['$rootScope', '$q', '$compile'];
    return PromptMessageService;
}());
export { PromptMessageService };
